import React from 'react'
import { createGlobalStyle } from 'styled-components'
import { PortalContext, usePortalState } from './PortalContext'
import tw, { styled, theme } from 'twin.macro'

interface EditorLayoutProps {
  header: React.ReactNode
  main: React.ReactNode
  aside: React.ReactNode
}

export default function EditorLayout(props: EditorLayoutProps) {
  const { header, main, aside } = props

  const [portal, portalRef] = usePortalState()

  return (
    <>
      <PortalContext.Provider value={portal}>
        <FixedWidthLayout ref={portalRef}>
          {header}
          <Wrapper>
            <Main>{main}</Main>
            <Aside>{aside}</Aside>
          </Wrapper>
        </FixedWidthLayout>
      </PortalContext.Provider>
      <EditorGlobalStyle />
    </>
  )
}

const wrapperPaddingTop = 24

const FixedWidthLayout = styled.div``

const Aside = styled.aside`
  display: flex;
  flex-direction: column;

  @media (min-width: ${theme`screens.md`}) {
    width: 284px;

    & > * + * {
      margin-top: 8px;
    }
  }
`

const Main = styled.main`
  @media (min-width: ${theme`screens.md`}) {
    width: 680px;
  }
`

const Wrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  ${tw`flex flex-col md:flex-row md:justify-between`}

  @media (min-width: ${theme`screens.md`}) {
    padding-top: ${wrapperPaddingTop}px;
  }
`

const EditorGlobalStyle = createGlobalStyle`
  [hidden] {
    display: none !important;
  }
`
